export default __webpack_public_path__ + "static/3bd-sizzle-reel-4eab7faa7cfadb4c066079187af3a7ec.mp4";